import { render } from "./CreateOrEditPriceChargeForm.vue?vue&type=template&id=21ba73c4&ts=true"
import script from "./CreateOrEditPriceChargeForm.vue?vue&type=script&lang=ts"
export * from "./CreateOrEditPriceChargeForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__